import { createAction, props } from '@ngrx/store';

export const setCommonIdBrowserTitle = createAction(
  '[Core] Set Common Id Browser Title',
  props<{ subTitle?: string; problemDetailFlag?: boolean }>()
);
